import React from "react";

const UpwardGreenArrowIcon = () => {
 return (
  <svg
   width="12"
   height="12"
   viewBox="0 0 12 12"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
  >
   <path
    d="M6.00003 11.3336C5.81123 11.3336 5.64723 11.264 5.50803 11.1248C5.36936 10.9862 5.30003 10.8224 5.30003 10.6336V3.31684L2.13363 6.48324C1.9891 6.62777 1.82776 6.70004 1.64963 6.70004C1.47203 6.70004 1.31096 6.62777 1.16643 6.48324C1.02243 6.33871 0.947497 6.17764 0.94163 6.00004C0.936297 5.82244 1.0059 5.66137 1.15043 5.51684L5.50003 1.16644C5.5779 1.08857 5.65843 1.03311 5.74163 1.00004C5.82483 0.966973 5.91096 0.950439 6.00003 0.950439C6.0891 0.950439 6.1779 0.966973 6.26643 1.00004C6.3555 1.03311 6.43336 1.08857 6.50003 1.16644L10.8496 5.51684C10.9942 5.66137 11.0664 5.82244 11.0664 6.00004C11.0664 6.17764 10.9942 6.33871 10.8496 6.48324C10.7056 6.62777 10.5419 6.70004 10.3584 6.70004C10.175 6.70004 10.011 6.62777 9.86643 6.48324L6.70003 3.33364V10.6336C6.70003 10.8224 6.6307 10.9862 6.49203 11.1248C6.35283 11.264 6.18883 11.3336 6.00003 11.3336Z"
    fill="#5DB594"
   />
  </svg>
 );
};

export default UpwardGreenArrowIcon;
